import React from 'react';

export interface PaymentErrorProps {
    readonly isSinglePaymentError?: boolean;
    readonly isBulkPaymentError?: boolean;
    readonly cancelPayment: () => void;
    readonly errorType: string;
    readonly errorTracking: (s: string) => void;
}

export const paymentErrorPage = (paymentErrorProps: PaymentErrorProps) => {
    const warningMessageHead = 'There\'s a lot happening over here...';
    const warningMessage = 'We\'re trying to process your request but we\'re experiencing some\n' +
        '                    issues on our end.';
    const goBackMessage = paymentErrorProps.isSinglePaymentError ? 'Go back to invoice' : 'Go back to invoice list';
    paymentErrorProps.errorTracking(paymentErrorProps.errorType);
    return (
        <div className='expired-link-warning'>
            <img src={require('../../assets/img/error-construction.png')} />
            <h1>{warningMessageHead}</h1>
            <br />
            <p>{warningMessage}</p>
            <br />
            <p>Please try again in a few minutes.</p>
            <br />
            <a onClick={() => paymentErrorProps.cancelPayment()}>{goBackMessage}</a>
        </div>
    );
};
